export default __webpack_public_path__ + "static/media/pictogramDebtConsolidation64.acd0e0eb.svg";